export default "__VITE_ASSET__CtdAaTmI__"